module.exports = __webpack_public_path__ + "media/clickSound.9c29861f.wav";